module.exports = __webpack_public_path__ + "img/CCLF_infographic-full.ea95dd78.png";